module.exports = __webpack_public_path__ + "img/expressjs.8f887594.svg";